import { FunctionComponent, useCallback } from 'react';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RoutesEnum } from 'src/types/navigation';
import { StyledBillingIcon, StyledBillingIconButton } from './styled';

const BillingButton: FunctionComponent = () => {
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        navigate(RoutesEnum.BILLING);
    }, [navigate]);

    return (
        <Tooltip title="Billing" arrow>
            <span>
                <StyledBillingIconButton
                    type="button"
                    onClick={handleClick}
                    aria-label="Go to billing"
                    size="small"
                >
                    <StyledBillingIcon />
                </StyledBillingIconButton>
            </span>
        </Tooltip>
    );
};

export default BillingButton;
